import React from 'react';
import illustration from '../../assets/illustration324.svg';
import SettingsForm from './SettingsForm';
import styles from './Settings.module.css';

const Settings = () => (
  <>
    <div className={styles.settings}>
      <SettingsForm />
      <img
        src={illustration}
        alt="illustration"
        className={styles.illustration}
      />
    </div>
  </>
);

export default Settings;
